import { render, staticRenderFns } from "./NewChange.vue?vue&type=template&id=5330cc7b&scoped=true"
import script from "./NewChange.vue?vue&type=script&lang=js"
export * from "./NewChange.vue?vue&type=script&lang=js"
import style0 from "./NewChange.vue?vue&type=style&index=0&id=5330cc7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330cc7b",
  null
  
)

export default component.exports